import React from 'react';
import { Alert, Card, CardBody, Col, Row, Media } from 'reactstrap';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import AuthService from '../services';
import logo from "../assets/img/QcompetitorLogo.png";
import Http from "../Http"
import queryString from 'query-string'

class Login extends React.Component {

	constructor(props) {
		super(props)

		this.state = {
			loading: false,
			btnLink: '',
			errors: ''
		};
	}

	componentDidMount() {

		if (this.props.location.search.length > 0) {
			const values = queryString.parse(this.props.location.search)
			if (values.code) {
				this.setState({ loading: true });
				this.props.dispatch(AuthService.login(values.code, values.state))
					.catch((err) => {
						console.log(err)
						this.setState({ errors: err.errors, loading: false });
					});
			} else if (values.error) {
				// l'utente non accetta i permessi
				this.setState({ errors: "Errore di autenticazione 1003", loading: false });
			}
		} else {
			this.setLoginLink()
		}

	}

	setLoginLink() {
		Http.get('/oauth/login')
			.then((response) => {
				this.setState({
					btnLink: response.data.login_link
				})
			}).catch((e) => {
				this.setState({ errors: 'Si è verificato un errore.', loading: false });
			});
	}

	render() {
		// const errors = this.validate(this.state.email, this.state.password);
		// const isEnabled = errors.email.length == 0 && errors.password.length == 0 && this.state.touched.password && this.state.touched.email;

		const { from } = this.props.location.state || { from: { pathname: '/' } };
		const { isAuthenticated } = this.props;
		if (isAuthenticated) {
			return (
				<Redirect to={from} />
			);
		}

		const { response, errors, loading } = this.state;

		return (
			<div className="content">
				<Row>
					<Col md={{ size: 6, offset: 3 }}>
						<Card className="mt-5">
							<Row>
								<Col md="12" className="text-center ">
									<Media className="m-3" object src={logo} alt="logo Qcompetitor" />
								</Col>
							</Row>
							<Row>
								<Col md="12"><h3 className="text-center p-3">Benvenuto in Qcompetitor</h3></Col>
							</Row>
							<CardBody className="text-center">
								{errors != '' ? (<div className="alert alert-danger" role="alert">
									{errors}
								</div>) : (<></>)}

								{errors != '' ? (<a href='/' className="btn btn-secondary">Riprova</a>) : (<a href={this.state.btnLink} disabled={this.state.loading} className={'btn btn-primary' + (this.state.loading ? ' btn-loading' : '')}>Esegui l'accesso</a>)}
							</CardBody>
						</Card>
					</Col>
				</Row>
			</div >
		)
	}
}

Login.propTypes = {
	dispatch: PropTypes.func.isRequired,
	isAuthenticated: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
	isAuthenticated: state.Auth.isAuthenticated,
});

export default connect(mapStateToProps)(Login);